module.exports = __webpack_public_path__ + "static/media/secondary-manual.db78f564.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/secondary-manual.jpg
// module id = 147
// module chunks = 0